module.exports = __webpack_public_path__ + "static/media/hint.2274d79d.png";